/**
 * @generated SignedSource<<57263b19ebcef3340efcf6d95e9ce968>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type RecommendedPagesSpaceBehavior = "HIDDEN" | "SHOWN" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type EndOfPageRecommendation_spaceStatusReader$data = {
  readonly defaultBehavior: RecommendedPagesSpaceBehavior;
  readonly recommendedPagesEnabled: boolean;
  readonly " $fragmentType": "EndOfPageRecommendation_spaceStatusReader";
};
export type EndOfPageRecommendation_spaceStatusReader$key = {
  readonly " $data"?: EndOfPageRecommendation_spaceStatusReader$data;
  readonly " $fragmentSpreads": FragmentRefs<"EndOfPageRecommendation_spaceStatusReader">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "throwOnFieldError": true
  },
  "name": "EndOfPageRecommendation_spaceStatusReader",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "recommendedPagesEnabled"
    },
    {
      "kind": "ScalarField",
      "name": "defaultBehavior"
    }
  ],
  "type": "RecommendedPagesSpaceStatus"
};

(node as any).hash = "a2f42efc3e53fde257cbd04ff453a827";

export default node;
